var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpactE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 49,
    fill: "none",
    viewBox: "0 0 52 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A8",
    d: "M51.02 24.423c0 2.592-3.226 4.652-3.986 6.991-.76 2.34.583 5.987-.887 8.005-1.469 2.019-5.303 1.824-7.337 3.31-2.036 1.487-2.99 5.177-5.413 5.962-2.424.785-5.295-1.647-7.887-1.647-2.593 0-5.54 2.407-7.887 1.647-2.348-.76-3.378-4.492-5.413-5.962-2.035-1.469-5.852-1.266-7.338-3.31-1.486-2.043-.093-5.573-.886-8.005C3.192 28.982 0 27.014 0 24.423c0-2.593 3.226-4.653 3.986-6.992.76-2.34-.583-5.987.886-8.005 1.47-2.018 5.303-1.824 7.338-3.31C14.245 4.629 15.2.939 17.623.154c2.424-.785 5.294 1.689 7.887 1.689 2.592 0 5.54-2.407 7.887-1.689 2.347.718 3.377 4.492 5.413 5.962 2.034 1.469 5.851 1.266 7.337 3.31 1.487 2.043.093 5.573.887 8.005.794 2.432 3.986 4.4 3.986 6.992Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 24,
    r: 17,
    fill: "#fff",
    stroke: "#A6A6A8",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A8",
    d: "M20.148 32.5V15.695h11.637v2.953H23.43v3.727h7.617v2.93H23.43v4.265h8.355v2.93H20.148Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactE);
export default __webpack_public_path__ + "static/media/ImpactE.589fd361.svg";
export { ForwardRef as ReactComponent };